export default __webpack_public_path__ + "static/media/rate_end_logo.c141db55.png";